import { makeFetcher } from '@/utils/fetch';
import { config } from '@/config';
import {
    ISurveyEndParticipationFeedback,
    ISurveyEndParticipationSummary,
} from '@/types/types/forms/surveyEnd/surveyEnd.interface';
import { getJson } from '@/utils/fp';

const makeSurveyEndService = (apiUrl: string) => {
    const fetcher = makeFetcher(apiUrl);

    return {
        getParticipationSummary: async (surveyKey: string, userId: string) =>
            fetcher
                .get(`?surveyKey=${surveyKey}&userId=${userId}`, { disableRedirects: true })
                .then(getJson) as Promise<ISurveyEndParticipationSummary>,

        saveParticipationFeedbackResponses: async (data: ISurveyEndParticipationFeedback) =>
            fetcher.post(`/feedback`, JSON.stringify(data)),
    };
};

export const surveyEndService = makeSurveyEndService(config.api.url.surveyEnd);
